module.exports = __webpack_public_path__ + "static/media/twitter-black.2413d0e1.svg";